import React from 'react';
import { isString } from 'lodash';
import {
  compose,
  withHandlers,
  withPropsOnChange,
  defaultProps,
  withProps,
  branch,
} from 'recompose';
import cx from 'classnames';
import { once } from 'lodash';
import Icon from 'components/Icon';

import withField from '../withField';
import createLabel from '../createLabel';

import styles from './styles.css';

export type Props = {
  disabled?: boolean;
  type?: string;
  error?: string;
  label?: string;
  value?: string;
  onFocus?: (FormEvent) => void;
  onBlur?: (FormEvent) => void;
  onChange?: (FormEvent) => void;
  theme?: 'normal' | 'rounded' | 'dark';
  size?: 'small' | 'medium' | 'large';
  style?: any;
  autofocus?: boolean;
  iconBefore?: string;
  iconAfter?: string;
  placeholder?: string;
};

export type OwnProps = Props & {
  theme: string;
  size: string;
  iconBefore: JSX.Element | undefined;
  iconAfter: JSX.Element | undefined;
  onKeyPress?: () => void;
};

export const TextArea = compose<OwnProps, Props>(
  defaultProps({ theme: 'normal', size: 'medium', type: 'text' }),
  withPropsOnChange(
    ['label'],
    ({ label, input }) =>
      !!label && {
        label: React.createElement(
          isString(label) ? createLabel(label) : label,
          { className: styles.label, htmlFor: input.name }
        ),
      }
  )
)(
  ({
    disabled,
    type,
    error,
    label,
    value,
    placeholder,
    autofocus,
    defaultValue,
    onFocus,
    onBlur,
    onChange,

    theme,
    size,
    style,
  }) => (
    <div
      style={style}
      className={cx(
        styles.root,
        styles[`theme-${theme}`],
        styles[`size-${size}`],
        error && styles.hasError,
        disabled && styles.disabled
      )}
    >
      {label}
      <div className={styles.wrapper}>
        <textarea
          autoFocus={autofocus}
          disabled={disabled}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          className={styles.textarea}
        />
      </div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  )
);

export default withField(TextArea);
